import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_450'),
        action: obj => {
          this.createDialog('PayBillDialog', {
            data: [obj],
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: (obj) => ({
          validate: this.cloudEnv === 'on_pay',
        }),
      },
      {
        label: i18n.t('scope.text_456'),
        action: obj => {
          this.createDialog('CancleBillDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: (obj) => ({
          validate: this.cloudEnv === 'on_pay',
        }),
      },
    ]
  },
}
